export class InvoiceableItems {
    testQuotationLines?: TestQuotationLineItem[];
    packageQuotationLines?: PackageQuotationLineItem[];
    customerPackages?: Item[];
    subGroups?: string[];
    tests?: Item[];
    packages?: Item[];
    testBundles?: string;

    constructor() {
        this.testQuotationLines = [];
        this.packageQuotationLines = [];
        this.customerPackages = [];
        this.subGroups = [];
        this.tests = [];
        this.packages = [];
        this.testBundles = null;
    }
}

export class Item {
    constructor(code: string, subGroupCode: string = null) {
        this.code = code;
        this.subGroupCode = subGroupCode;
    }
    code: string;
    subGroupCode?: string;
}

export class TestQuotationLineItem {
    constructor(testCode: string = null, subGroupCode: string = null, code: string = null) {
        this.testCode = testCode;
        this.code = code
        this.subGroupCode = subGroupCode;
    }
    testCode?: string;
    code?: string;
    subGroupCode?: string;
}

export class PackageQuotationLineItem {
    constructor(packageCode: string = null, subGroupCode: string = null, code: string = null) {
        this.packageCode = packageCode;
        this.code = code
        this.subGroupCode = subGroupCode;
    }
    packageCode?: string;
    code?: string;
    subGroupCode?: string;
}
